export default () => {
  const urlParams = new URLSearchParams(window.location.search);
  const keyword = urlParams.get('keyword');
  if (keyword) {
    const span = document.querySelector('h1 span');
    if (span && span.getAttribute('data-keyword') === 'true') {
      import('sanitize-html').then((sanitize) => {
        span.innerText = sanitize.default(keyword);
      });
    }
  }
};
